import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.305 6h-1.18a.75.75 0 1 0 0 1.5h3a.75.75 0 0 0 .75-.75v-3a.75.75 0 1 0-1.5 0v1.2l-.412-.412a5.25 5.25 0 0 0-7.425 0 5.25 5.25 0 0 0 0 7.425 5.25 5.25 0 0 0 7.425 0 .751.751 0 0 0-1.062-1.062 3.75 3.75 0 1 1 0-5.304z"
    }, null, -1)
  ]))]))
}
export default { render: render }